var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"house"},[_c('h1',{staticClass:"tit"},[_vm._v("keylock #6600-92 92A操作手册")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }